/* ═══════════════════════════════════════════════════════════
   Maelove Blog Redesign — JavaScript
   Fade-in animations + reference toggle
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // Fade-in animation via IntersectionObserver
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.blog-redesign .fade-in').forEach(function(el) {
    observer.observe(el);
  });

  // Reference toggle (called from onclick in the body_html)
  window.toggleRefs = function() {
    var list = document.getElementById('refList');
    var btn = document.getElementById('refToggle');
    if (!list || !btn) return;
    var arrow = btn.querySelector('.arrow');

    if (list.classList.contains('show')) {
      list.classList.remove('show');
      btn.classList.remove('open');
      if (arrow) arrow.textContent = '▼';
    } else {
      list.classList.add('show');
      btn.classList.add('open');
      if (arrow) arrow.textContent = '▲';
    }
  };
})();
